module.exports = __webpack_public_path__ + "static/img/6.0c49ac5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/6.jpg
// module id = UlYV
// module chunks = 2